import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const Placement = {
  List: lazyNamed(() => import('./containers/PlacementsList/index.tsx'), 'PlacementsList'),
  Edit: lazyNamed(() => import('./containers/PlacementEdit/index.tsx'), 'PlacementEditPage'),
  History: lazyNamed(() => import('./containers/PlacementHistory.tsx'), 'PlacementHistory'),
};
